import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { Form } from 'informed';
import { func, number, string } from 'prop-types';
import { useQuantity } from '@magento/peregrine/lib/talons/CartPage/ProductListing/useQuantity';
import { useStyle } from '@magento/venia-ui/lib/classify';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import { Message } from '@magento/venia-ui/lib/components/Field';
import MinusIcon from '../../../../../components/Common/Icons/minusIcon';
import PlusIcon from '../../../../../components/Common/Icons/plusIcon';
import defaultClasses from './quantity.module.css';
export var QuantityFields = function QuantityFields(props) {
  var initialValue = props.initialValue,
      itemId = props.itemId,
      label = props.label,
      min = props.min,
      onChange = props.onChange,
      message = props.message,
      _props$max = props.max,
      max = _props$max === void 0 ? 0 : _props$max,
      _props$field = props.field,
      field = _props$field === void 0 ? 'quantity' : _props$field;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var classes = useStyle(defaultClasses, props.classes);
  var iconClasses = {
    root: classes.icon
  };
  var talonProps = useQuantity({
    initialValue: initialValue,
    min: min,
    max: max,
    onChange: onChange,
    field: field
  });
  var isDecrementDisabled = talonProps.isDecrementDisabled,
      isIncrementDisabled = talonProps.isIncrementDisabled,
      isIncrementDisabledManually = talonProps.isIncrementDisabledManually,
      handleBlur = talonProps.handleBlur,
      handleDecrement = talonProps.handleDecrement,
      handleIncrement = talonProps.handleIncrement,
      maskInput = talonProps.maskInput;
  var errorMessage = message ? React.createElement(Message, null, message) : null;
  return React.createElement(Fragment, null, React.createElement("div", {
    className: classes.root
  }, React.createElement("label", {
    className: classes.qtyLabel + ' w-20 text-h6 pr-4 lg_pr-1 xl_pr-4 self-center justify-start leading-160 text-black',
    htmlFor: itemId
  }, "QTY"), React.createElement("button", {
    "aria-label": formatMessage({
      id: 'quantity.buttonDecrement',
      defaultMessage: 'Decrease Quantity'
    }),
    className: classes.button_decrement,
    disabled: isDecrementDisabled,
    onClick: handleDecrement,
    type: "button"
  }, React.createElement(MinusIcon, null)), React.createElement(TextInput, {
    "aria-label": formatMessage({
      id: 'quantity.input',
      defaultMessage: 'Item Quantity'
    }),
    classes: {
      input: classes.input,
      mode_light: classes.inputWidth
    },
    field: field,
    id: itemId,
    inputMode: "numeric",
    mask: maskInput,
    min: min,
    onBlur: handleBlur,
    pattern: "[0-9]*"
  }), React.createElement("button", {
    "aria-label": formatMessage({
      id: 'quantity.buttonIncrement',
      defaultMessage: 'Increase Quantity'
    }),
    className: classes.button_increment,
    disabled: isIncrementDisabled || isIncrementDisabledManually,
    onClick: handleIncrement,
    type: "button"
  }, React.createElement(PlusIcon, null))), errorMessage);
};
export var Quantity = function Quantity(props) {
  return React.createElement(Form, {
    initialValues: {
      quantity: props.initialValue
    }
  }, React.createElement(QuantityFields, props));
};
Quantity.propTypes = {
  initialValue: number,
  itemId: string,
  label: string,
  min: number,
  onChange: func,
  message: string
};
Quantity.defaultProps = {
  label: 'Quantity',
  min: 0,
  initialValue: 1,
  onChange: function onChange() {}
};
QuantityFields.defaultProps = {
  min: 0,
  initialValue: 1,
  onChange: function onChange() {}
};
export default Quantity;